var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oauth-callback" },
    [
      _c("LoadingBounce"),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "basic-modal no-header-modal hide-cancel-btn",
          attrs: {
            id: "basic-error-alert",
            "hide-header": true,
            "ok-title": _vm.$t("common.confirm")
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("common.modal.basic_error_alert.message")
              )
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0104e8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0104e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/auth/views/OAuthCallback.vue
// module id = vbWt
// module chunks = 1